import { createAction, props } from '@ngrx/store';
import { Role } from './roles.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records role'
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records role success', 
    props<{ listData: Role[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records role failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record role',
    props<{id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record role success', 
    props<{ singleData: Role }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record role failure', 
    props<{ error: string }>()
);


// Add Data
export const addRecord = createAction(
    '[Data] Add record role',
    props<{ newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record role success'
);
export const addRecordFailure = createAction(
    '[Data] Add record role failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record role',
    props<{ id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record role success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record role failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record role',
    props<{ id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record role success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record role failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state role',
);